import { endOfDay, format, parse } from 'date-fns';
import config from '../../config';
import FetchHelper from './OldFetchHelper';

class OrderHelper {
  async getOrders(filter) {
    const filters = filter ? this.getFiltersFetchConfig(filter) : ``;

    const fetchConfig = {
      path: `${config.api.paths.customers.basepath}${config.api.paths.customers.paths.orders}${filters}`,
    };

    const fetchResult = await FetchHelper.get(fetchConfig);

    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return {
      count: fetchResult.count,
      data: fetchResult.data,
    };
  }

  getFiltersFetchConfig(filter) {
    let filters = [];
    if(filter.orderId) {
      filters = [...filters, `orderId=${filter.orderId}`];
    }
    if(filter.dateFrom) {
      const parsedDate = parse(filter.dateFrom, `dd.MM.yyyy`, 0);
      const dateFrom = format(parsedDate, `yyyy-MM-dd'T'HH:mm:ss`);
      filters = [...filters, `dateFrom=${dateFrom}`];
    }
    if(filter.dateTo) {
      const parsedDate = endOfDay(parse(filter.dateTo, `dd.MM.yyyy`, 0));
      const dateTo = format(parsedDate, `yyyy-MM-dd'T'HH:mm:ss`);
      filters = [...filters, `dateTo=${dateTo}`];
    }
    if(filter.searchString) {
      filters = [...filters, `searchString=${filter.searchString}`];
    }
    if(filter.status) {
      filters = [...filters, `status=${filter.status}`];
    }
    if(filter.limit) {
      filters = [...filters, `limit=${filter.limit}`];
    }
    return filters.length > 0 ? `/?${filters.join(`&`)}` : ``;
  }
}

export default new OrderHelper();
